import { useQuery } from "react-query";
import {
  getUserTestList,
  getOpenTradeOrdersList,
  getTradeList,
  getTransactionList,
  getApiDashBoardData,
  MetaDataList,
  FetchSecurityMaster
} from "../api/api";

function useUserList(ClientID:any,token: any) {
  return useQuery(["fetch-user-list", token], () => getUserTestList(ClientID, token), {
    keepPreviousData: true,
    refetchOnWindowFocus: false,
  });
}

function useTransationList(listType: any, client:any, token: any) {
  return useQuery(
    ["fetch-transation-list", token],
    () => getTransactionList(listType, client, token),
    {
      keepPreviousData: true,
      refetchOnWindowFocus: false,
    }
  );
}
function useTransationListPending(listType: any,client:any, token: any) {
  return useQuery(
    ["fetch-pendingtransation-list", token],
    () => getTransactionList(listType, client, token),
    {
      keepPreviousData: true,
      refetchOnWindowFocus: false,
    }
  );
}

function useFetchOpenTradeOrders(token: any) {
  return useQuery(
    ["fetch-trade-orders", "2022-06-01", "2022-12-31", token],
    () => getOpenTradeOrdersList("2022-06-01", "2022-12-31", token),
    {
      keepPreviousData: true,
      refetchOnWindowFocus: false,
    }
  );
}
function useFetchTradeList(token: any) {
  return useQuery(
    ["fetch-open-orders", "2022-06-01", "2022-12-31", token],
    () => getTradeList("2022-06-01", "2022-12-31", token),
    {
      keepPreviousData: true,
      refetchOnWindowFocus: false,
    }
  );
}

function useGetDashboardData(RequestType: any,client:any, token: any) {
  return useQuery(
    ["fetch-dashboard-data", token],
    () => getApiDashBoardData(RequestType, client, token),
    {
      keepPreviousData: true,
      refetchOnWindowFocus: false,
    }
  );
}

function useGetMetadataList(clientID: any, token: any) {
  return useQuery(
    ["fetch-MetaList", clientID, token ],
    () => MetaDataList(clientID, token),
    {
      keepPreviousData: true,
      refetchOnWindowFocus: false,
    }
  );
}

function useGetFundList(RequestType: any,client:any, token: any) {
  return useQuery(
    ["fetch-FundList", token],
    () => FetchSecurityMaster(RequestType, client, token),
    {
      keepPreviousData: true,
      refetchOnWindowFocus: false,
    }
  );
}
function useGetParticipantList(RequestType: any, client: any, token: any) {
  return useQuery(
    ["fetch-ParticipantList", client, token], // Use a different query key
    () => FetchSecurityMaster(RequestType, client, token), // Use a different fetch function
    {
      keepPreviousData: true,
      refetchOnWindowFocus: false,
    }
  );
}

export {
  useUserList,
  useFetchOpenTradeOrders,
  useFetchTradeList,
  useTransationList,
  useTransationListPending,
  useGetDashboardData,
  useGetMetadataList,
  useGetFundList,
  useGetParticipantList
};
